import { defaultTrainingData } from '../../../../backend/config/classifiers/defaults/DefaultTrainingData';
import { trainingSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers, allowManageSkillsAndTrainingsClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const trainingEntityName = 'training';
const trainingColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { description: {
        type: 'string-required',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineTrainingClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: trainingColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { description: params.data.description, search: [params.data.name, params.data.status, params.data.description].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState) && !allowManageSkillsAndTrainingsClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultTrainingData,
        publicData: true,
    }, trainingSchema);
}
